import Fees from '@/components/booking-summary/Fees';
import NonTrips from '@/components/booking-summary/NonTrips';
import RefundTotal from '@/components/booking-summary/RefundTotal';
import Trips from '@/components/booking-summary/Trips';
import Vouchers from '@/components/booking-summary/Vouchers';
import { type BookingSummaryData } from '@/hooks/useBookingSummaryData';
import type { FC } from 'react';

const SummaryContent: FC<Omit<BookingSummaryData, 'displayPrice'>> = ({
  inboundTrips,
  outboundTrips,
  nonTripOffers,
  fees,
  vouchers,
  passengersMap,
  travelAccountsMap,
  reservationFeesMap,
  refundTotal,
}) => {
  return (
    <>
      {!!outboundTrips.length && (
        <Trips
          trips={outboundTrips}
          passengersMap={passengersMap}
          reservationFeesMap={reservationFeesMap}
          direction="outbound"
        />
      )}
      {!!inboundTrips.length && (
        <Trips
          trips={inboundTrips}
          passengersMap={passengersMap}
          reservationFeesMap={reservationFeesMap}
          direction="inbound"
        />
      )}
      {!!nonTripOffers.length && (
        <NonTrips
          nonTripsOffers={nonTripOffers}
          passengersMap={passengersMap}
          travelAccountsMap={travelAccountsMap}
        />
      )}
      {!!fees.length && <Fees fees={fees} />}
      {!!vouchers.length && <Vouchers vouchers={vouchers} />}
      {!!refundTotal && <RefundTotal refundTotal={refundTotal} />}
    </>
  );
};

export default SummaryContent;
